module.exports = __webpack_public_path__ + "img/blue-sky-background.1aa0e4c7.jpg";